import React from 'react';
import PropTypes from 'prop-types';
import {
  Row,
  Col,
  Label,
  Input
} from 'reactstrap';

import './SelectorSwitch.css';

const SelectorSwitch = (props) => {

  function handleChange() {
    props.handleCheckedOption(!props.checkValue);
  }

  const customClass = `custom-switch-component ${props.size}`;

  return (
    <Col sm="auto" className={customClass}>
      <Row className="auto-margin no-gutters">
        <Col sm="auto" className="formGroup">
          <Label check className="label-component">
            <Input
              name="switch"
              data-test-id={props.dataTestLabel}
              className="custom-control-input"
              type="checkbox"
              checked={props.checkValue}
              onChange={handleChange}
              disabled={props.readOnly}
            />
            <span className="slider round" />
          </Label>
        </Col>
        <Col sm="auto">
          <Label className="switch-label-text" htmlFor="switch">
            {props.label}
          </Label>
        </Col>
      </Row>
    </Col>
  );
};

SelectorSwitch.propTypes = {
  label: PropTypes.string,
  dataTestLabel: PropTypes.string,
  checkValue: PropTypes.bool,
  readOnly: PropTypes.bool,
  size: PropTypes.string,
  handleCheckedOption: PropTypes.func
};

SelectorSwitch.defaultProps = {
  label: '',
  dataTestLabel: 'data-test-id-switch',
  checkValue: false,
  readOnly: false,
  size: 'normal',
  handleCheckedOption: () => {}
};

export default SelectorSwitch;
